import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useMemo, useState } from 'react';
import { cultureContext } from '../contexts';
import { fetchTenantCulture, tenantToCustomerCulture } from '../helpers';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This provider is intended to work in CSR.
 *
 * @param props ClientCultureContextProviderProps
 * @returns FC
 */
export var ClientCultureContextProvider = function ClientCultureContextProvider(props) {
  var host = props.host,
    tenant = props.tenant,
    children = props.children;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    tenantCulture = _useState2[0],
    setTenantCulture = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedCultureCode = _useState4[0],
    setSelectedCultureCode = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    customerCulture = _useState6[0],
    setCustomerCulture = _useState6[1];
  useEffect(function () {
    if (!tenantCulture) {
      setCustomerCulture(undefined);
      return;
    }
    var selectedCustomerCulture = tenantToCustomerCulture(tenantCulture, selectedCultureCode);
    setCustomerCulture(selectedCustomerCulture);
  }, [tenantCulture, selectedCultureCode]);
  useEffect(function () {
    (async function () {
      var fetchedTenantCulture = await fetchTenantCulture(host, tenant);
      setTenantCulture(fetchedTenantCulture);
    })();
  }, [host, tenant]);
  useEffect(function () {
    var lang = document.documentElement.lang;
    if (lang) {
      setSelectedCultureCode(lang);
    }
  }, []);
  var contextValue = useMemo(function () {
    return {
      culture: customerCulture,
      getSelectedCultureCode: function getSelectedCultureCode() {
        return customerCulture === null || customerCulture === void 0 ? void 0 : customerCulture.CultureCode;
      }
    };
  }, [customerCulture]);
  return /*#__PURE__*/_jsx(cultureContext.Provider, {
    value: contextValue,
    children: children
  });
};